// Backend guards on partner setup return 422s with hand-written messages the
// user is expected to read. The frontend routes these to an inline banner
// rather than a toast so a stale client state (a tag or team was deleted
// between page load and submit) shows the user why the action is refused and
// where to go next. The match is pinned to the exact backend strings so a
// copy tweak does not silently fall back to the generic toast path.

const EXPENSE_TAG_MESSAGES = new Set([
  "At least one expense tag must exist before a team can be created.",
  "At least one expense tag must exist before activating a wallet.",
  "At least one expense tag must exist before a user wallet can be assigned.",
]);

const STALE_TEAM_SELECTION_MESSAGES = new Set([
  "Team not found.",
]);

const messageOf = (error) => {
  const raw = error?.response?.data?.message;
  return typeof raw === "string" ? raw : null;
};

export const isExpenseTagPrerequisiteError = (error) => {
  if (error?.response?.status !== 422) return false;
  const message = messageOf(error);
  return message !== null && EXPENSE_TAG_MESSAGES.has(message);
};

// Fires when the team_id the client sent no longer resolves to a real team on
// the server, i.e. the dropdown selection is stale (the team was renamed or
// deleted between page load and submit). This is not the same as "no teams
// exist"; the frontend gates that upstream. The right response here is to
// invalidate the teams cache so the dropdown reloads, and to tell the user
// their selection is no longer valid, not that they need to add a team.
export const isStaleTeamSelectionError = (error) => {
  if (error?.response?.status !== 422) return false;
  const message = messageOf(error);
  return message !== null && STALE_TEAM_SELECTION_MESSAGES.has(message);
};

export const prerequisiteMessageFor = (error, fallback) =>
  messageOf(error) ?? fallback;
